import { lockBodyScroll, unlockBodyScroll } from '@/utils/bodyScrollLock'

export default {
  watch: {
    show: {
      immediate: true,
      handler (val) {
        val ? lockBodyScroll() : unlockBodyScroll()
      }
    }
  },
  beforeDestroy () {
    if (this.show) unlockBodyScroll()
  }
}
